import "./Services.module.css";
import CorporateHeader from "@/reusable_sections/Header";
import ExpertiseForEveryAcre from "./sections/ExpertiseForEveryAcre";
import CreationRoadmap from "./sections/CreationRoadmap";
import CertificationsAndWarranty from "./sections/CertificationsAndWarranty";
import ReadyToMixSolutions from "./sections/ReadyToMixSolutions";
import GlobalFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <CorporateHeader />
      <ExpertiseForEveryAcre />
      <ReadyToMixSolutions />
      <CreationRoadmap />
      <CertificationsAndWarranty />
      <GlobalFooter />
    </div>;
}